'use strict';

/*******************************************************************************
 Stripe Helper Functions to deal with the Stripe Payment Implementation
*******************************************************************************/
class StripeFormHelper {

	constructor(form) {
		this.form = form;
	}

	getResponseHandler() {
		return (status, response) => {
			if (response.error) {
				// Show the errors on the form
				this.form.find('#payment-errors').removeClass('hidden').html(response.error.message);
				this.form.find('button').prop('disabled', false);
			} else {
				// token contains id, last 4, and card type
				let token = response.id;

				this.form.find('#payment-errors').addClass('hidden');
				// Insert the token into the form so it gets submitted to the server
				this.form.append($('<input type="hidden" name="stripeToken" id="stripe-token"/>').val(token));
				// and submit
				this.form.get(0).submit();
			}
		}
	}

	getCardDataFromForm() {
		return {
			number: this.form.find('#cc-number').val(),
			cvc: this.form.find('#cc-cvc').val(),
			exp_month: this.form.find('#cc-month').val(),
			exp_year: this.form.find('#cc-year').val()
		};
	}

	createToken() {
		let cardData = this.getCardDataFromForm();

		return Stripe.card.createToken(cardData, this.getResponseHandler());
	}
}
